import { render, staticRenderFns } from "./EmployerBar.vue?vue&type=template&id=308a94d5&scoped=true"
import script from "./EmployerBar.vue?vue&type=script&lang=js"
export * from "./EmployerBar.vue?vue&type=script&lang=js"
import style0 from "./EmployerBar.vue?vue&type=style&index=0&id=308a94d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a94d5",
  null
  
)

export default component.exports